/**
 * A per-replay token the replay loop checks between steps: a cancelled replay stops with a
 * `ReplayCancelledError`. Nothing cancels a replay today — each runs to its end, and a failure ends
 * in a reload (decision 17); the token is the seam for a title that must abort one.
 */

export class ReplayCancellationToken {
    private cancelled = false;
    private cancelReason: string | null = null;
  
    public cancel(reason?: string): void {
      this.cancelled = true;
      this.cancelReason = reason ?? "cancelled";
    }
  
    public isCancelled(): boolean {
      return this.cancelled;
    }
  
    public getReason(): string | null {
      return this.cancelReason;
    }
  }